import React from "react";
import R from "ramda";
import ContactGroupEditorLink from "./ContactGroupEditorLink";
import { secondaryButtonStyles, LIGHT_GREY } from "../../common/styles";
import { LIGHT_TEXT_COLOR } from "../../common/styles";

export const Group = (props) => (
    <div style={{padding: "3px 0"}}>
        <label>
            <input type="checkbox"
                   className="x-group"
                   checked={props.checked}
                   onChange={ event => props.onChange(event.target.checked, props.value) } />
            <span style={{marginLeft: 5}}>{`${props.value.name} (${props.value.contacts.length})`}</span>
        </label>
        {
            props.isEditable
                ? <div style={{display: "inline-block"}}><ContactGroupEditorLink contactGroupId={props.value.id} /></div>
                : null
        }
    </div>
);
Group.propTypes = {
    checked: React.PropTypes.bool,
    isEditable: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    value: React.PropTypes.object
};

class ContactGroupsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectAll: false,
            selectedAuthor: props.authorId,
            selectedGroups: []
        };

        this._handleSelectAuthor = this._handleSelectAuthor.bind(this);
        this._handleSelectGroup = this._handleSelectGroup.bind(this);
        this._handleSelectAll = this._handleSelectAll.bind(this);
    }

    render() {
        let groups;

        if (Object.keys(this.props.groups).length === 0) {
            groups = <em>No contact groups defined. </em>
        } else {
            const sortByGroupName = R.sortBy(R.prop("name"));
            groups = sortByGroupName(this.props.groups[this.state.selectedAuthor]).map(group =>
                <Group key={group.id}
                       value={group}
                       checked={ this.state.selectedGroups.includes(group) }
                       isEditable={ this.state.selectedAuthor === this.props.authorId }
                       onChange={ this._handleSelectGroup } />
            );
        }

        const colleagues = Object.keys(this.props.groups)
                                 .filter(authorId => authorId !== this.props.authorId)
                                 .map(key => {
                                     const { authorId, authorName } = this.props.groups[key][0];
                                     return { authorId, authorName };
                                 });

        const sortByAuthorName = R.sortBy(R.prop("authorName"));
        const options = sortByAuthorName(colleagues).map(({ authorId, authorName }) =>
            <option key={authorId} value={authorId}>{ authorName }'s Groups</option>
        );

        return (
            <div className="x-details" style={{backgroundColor: LIGHT_GREY, borderRadius: "0 4px 4px 4px", padding: 10}}>
                <div>
                    <div>
                        <select value={ this.state.selectedAuthor }
                                onChange={ this._handleSelectAuthor }
                                className="x-author"
                                style={{ width: "100%" }} >
                            <option value={this.props.authorId}>My Contact Groups</option>
                            { options }
                        </select>
                    </div>

                    <div style={{margin: "10px 0 10px 0"}}>

                        <div style={{padding: "3px 0"}}>
                            <input className="x-select-all"
                                   type="checkbox"
                                   onChange={ this._handleSelectAll }
                                   checked={ this.state.selectAll } />
                            <span style={{color: LIGHT_TEXT_COLOR, marginLeft: 5}}>All/None</span>
                        </div>

                        <div style={{ maxHeight: 200, overflow: "auto" }}>
                            { groups }
                        </div>

                        { (this.state.selectedAuthor === this.props.authorId)
                            ? <ContactGroupEditorLink style={{ padding: "3px 10px" }} />
                            : undefined }

                    </div>

                    <input style={secondaryButtonStyles}
                           className="pure-button x-add-contact-groups"
                           type="button"
                           value="Use Selected Groups"
                           onClick={() => {
                            this.props.onChange(this.state.selectedGroups);
                            this.props.onComplete();
                           }}/>
                </div>


            </div>
        );
    }

    _handleSelectAuthor(event) {
        this.setState({
            selectAll: false,
            selectedAuthor: event.currentTarget.value,
            selectedGroups: []
        });
    }

    _handleSelectAll(event) {
        const selectedGroups = event.target.checked ? this.props.groups[this.state.selectedAuthor] : [];

        this.setState({
            selectAll: event.target.checked,
            selectedGroups
        });
    }

    _handleSelectGroup(checked, group) {
        let selectedGroups;

        if (checked) {
            selectedGroups = this.state.selectedGroups.concat(group);
        } else {
            selectedGroups = this.state.selectedGroups.filter(g => g !== group);
        }

        this.setState({
            selectAll: selectedGroups.length === 0 ? false  : this.state.selectAll,
            selectedGroups
        });
    }
}
ContactGroupsList.propTypes = {
    authorId: React.PropTypes.string.isRequired,
    groups: React.PropTypes.object,
    onChange: React.PropTypes.func
};

export default ContactGroupsList;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/components/ContactGroupsList.js
 **/